import { message } from "antd";
import { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { useNavigate, useSearchParams } from "react-router-dom";

import { AuthActions } from "app/redux/actions";
import { AuthSelectors } from "app/redux/reducers";

const AuthAssertion = ({ getMe, authenticateToken }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleAuth = useCallback(async () => {
    try {
      const accessToken = searchParams.get("accessToken");
      const refreshToken = searchParams.get("refreshToken");

      if (accessToken || refreshToken) {
        authenticateToken({ accessToken, refreshToken });
        const me = await getMe();
        navigate(me?.profileType === 6 ? "/userCPFL" : "/partner");
        message.success(I18n.t("routes.login.messages.welcome"));
      }
    } catch (error) {
      navigate(I18n.t("routes.login.url"));
    }
  }, [authenticateToken, getMe, navigate, searchParams]);

  useEffect(() => {
    handleAuth();
  }, [handleAuth]);

  return (
    <>
      <div className="app-login">
        <div className="container-fluid">
          <div className="row justify-content-center align-items-center">
            Logando...
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  me: AuthSelectors.getMe(state),
});

const mapDispatchToProps = dispatch => ({
  authenticateToken: token => dispatch(AuthActions.authenticateToken(token)),
  getMe: () => dispatch(AuthActions.getMe()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthAssertion);
